export interface GlobalFooterLink {
  [key: string]: any;
  title: string;
  href: string;
  blankTarget?: boolean;
}
